import "./hotkeys-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { NuxHotkeysCard } from "./hotkeys-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";

export class NuxHotkeysCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Hotkeys Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Keyboard shortcuts",
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxHotkeysCard.makeWith(),
          }),
      },
      {
        title: "Raw",
        render: () => NuxHotkeysCard.makeWith(),
      },
    ];
  }
}
